'use client'

import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@ui/web/components'
import { typographyVariants } from '@ui/web/lib'
import { buildUrl } from '@helper/utils/format'
import cn from '@config/tailwind/cn'

import { authClient } from '~/auth/client'
import { UserNavigationButton } from '~/lib/user-navigation-button'

interface SignUpModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  className?: string
}

export function SignUpModal({ open, onOpenChange, className }: SignUpModalProps) {
  const { data: session } = authClient.useSession()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        showCloseButton={false}
        className={cn('max-h-[90dvh] w-full max-w-2xl gap-4 overflow-y-auto rounded-3xl', className)}
      >
        <DialogHeader>
          <DialogTitle className={cn(typographyVariants({ variant: 'headline-sm' }), 'text-neutral-black text-center')}>
            Daftar sebagai...
          </DialogTitle>
          <DialogDescription className='sr-only'>
            Pilih salah satu opsi di bawah untuk mendaftar ke aplikasi PiBo.
          </DialogDescription>
        </DialogHeader>

        <section className='flex w-full flex-wrap items-center justify-center gap-4'>
          <UserNavigationButton userType='teacher' mode='signup' disabled={session !== null} />
          <UserNavigationButton userType='parent' mode='signup' disabled={session !== null} />
          <UserNavigationButton userType='kid' mode='signup' disabled={session !== null} />
        </section>

        {session !== null && (
          <p className={cn(typographyVariants({ variant: 'body-sm' }), 'text-neutral-black text-center')}>
            Kamu sudah terdaftar. Silahkan{' '}
            <a className='underline' href={buildUrl('account', '/check-user').href}>
              masuk ke aplikasi
            </a>
            .
          </p>
        )}

        <div className='flex justify-center'>
          <DialogClose render={<Button variant='ghost'>Tutup</Button>} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
